<p
    #announcer
    aria-atomic="true"
    aria-live="assertive"
    class="sr-only"
    data-testid="tip-overlay-announcement"
    data-tip-announcement
    role="alert"
></p>

<ng-template #tipContent>
    @if (renderedTip()) {
        <div
            animate.enter="animate-slide-in"
            class="flex min-h-64 flex-col justify-center rounded-2xl bg-surface-A shadow-tip slide-from-bottom-xl motion-reduce:animate-none"
            data-testid="tip-overlay-toast"
            interactaReverseTheme
            [attr.data-severity]="severity()"
            [class]="dynamicClasses()"
            (animate.leave)="leave($event)"
        >
            <interacta-simple-tip
                [tip]="simpleTip()"
                (closeTip)="close()"
                (reload)="reload()"
            />
            <interacta-pro-tip
                [tip]="proTip()"
                (actionClicked)="actionClicked($event)"
                (closeTip)="close(proTip()?.closeCallback)"
            />
        </div>
    }
</ng-template>
